import React from 'react';
import PropTypes from 'prop-types';
import Link from '../common/Link';
import { priceFormat, bedsFormat, comma } from '../common/HelperFunctions';

const DevelopmentItem = ({
  street,
  town,
  county,
  reserved,
  properties,
  thumbnail,
  name,
  permalink,
  min_beds,
  max_beds,
  min_price,
  max_price,
  sold,
  banner,
  status,
}) => {
  const address = comma(street, town, county);
  const customPrice = sold + reserved === properties && (reserved ? 'RESERVED' : 'SOLD');
  return (
    <div className="development-item col-md-4 col-sm-6 col-lg-4">
      <div className="shadow">
        <div>
          <Link to={`/development/${permalink}`}>
            <img
              className="img-responsive"
              src={
                thumbnail
                  ? `/uploads/developments/${permalink}/thumbnail.jpg`
                  : '/images/development_tb.jpg'
              }
              alt={name}
            />
            {banner && (
              <div className="ribbon ribbon-top-left">
                <span>{banner}</span>
              </div>
            )}
          </Link>
        </div>
        <div className="container-fluid development-container">
          <h2 className="text-primary">
            <Link to={`/development/${permalink}`}>{name}</Link>
          </h2>
          <h4 className="address">{address}</h4>
          <table className="table table-icon compact">
            <tbody>
              <tr>
                <td>
                  <span className="icon-2x icon-bed text-primary" aria-hidden="true" />
                </td>
                <td>{bedsFormat(min_beds, max_beds)}</td>
              </tr>
              {status !== 'portfolio' && (
                <tr>
                  <td>
                    <span className="icon-2x icon-gbp text-primary" aria-hidden="true" />
                  </td>
                  <td>{customPrice || priceFormat(min_price, max_price, true)}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="dev-button">
          <div>
            <Link to={`/development/${permalink}`}>
              View Development <span className="icon-chevron-right" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

DevelopmentItem.propTypes = {
  name: PropTypes.string.isRequired,
  town: PropTypes.string.isRequired,
  county: PropTypes.string.isRequired,
  min_beds: PropTypes.number.isRequired,
  max_beds: PropTypes.number.isRequired,
  permalink: PropTypes.string.isRequired,
  properties: PropTypes.number.isRequired,
  min_price: PropTypes.number,
  max_price: PropTypes.number,
  reserved: PropTypes.number,
  sold: PropTypes.number,
  thumbnail: PropTypes.number,
};

export default DevelopmentItem;
